import { SxProps, Theme } from '@mui/material';

export type PickerTone = 'primary' | 'warning' | 'neutral';

export function outlinedPickerSx(tone: PickerTone): SxProps<Theme> {
    if (tone === 'neutral') {
        return {};
    }
    return {
        '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: `${tone}.main` },
            '&:hover fieldset': { borderColor: `${tone}.dark` },
            '&.Mui-focused fieldset': { borderColor: `${tone}.dark` },
        },
        '& .MuiInputLabel-root': { color: `${tone}.main` },
    };
}
